import { useTranslation } from 'react-i18next';

export const useTranslationArray = (key: string): string[] => {
  const { t } = useTranslation();
  const value: unknown = t(key, { returnObjects: true });

  return Array.isArray(value) ? (value as string[]) : [];
};
